import { useEffect } from "react";
import { useUserDataContext } from "../context/UserDataContext";

function lightenColor(hex: string, percent: number): string {
  // Remove # prefix
  const h = hex.replace("#", "");
  const num = parseInt(h, 16);
  const r = Math.min(255, (num >> 16) + Math.round(255 * percent / 100));
  const g = Math.min(255, ((num >> 8) & 0x00FF) + Math.round(255 * percent / 100));
  const b = Math.min(255, (num & 0x0000FF) + Math.round(255 * percent / 100));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { firmData } = useUserDataContext();

  useEffect(() => {
    // Custom branding is only available on free trial or elite tier
    const canCustomize = firmData?.isOnTrial || firmData?.subscriptionStatus === "elite";

    const primary = canCustomize && firmData?.branding?.primaryColor
      ? firmData.branding.primaryColor
      : "#0F5132";
    const accent = canCustomize && firmData?.branding?.accentColor
      ? firmData.branding.accentColor
      : "#198754";
    const primaryHover = lightenColor(primary, 12);

    const root = document.documentElement;
    root.style.setProperty("--color-primary", primary);
    root.style.setProperty("--color-primary-hover", primaryHover);
    root.style.setProperty("--color-accent", accent);
    // Light tint for backgrounds (90% white blend)
    const num = parseInt(primary.replace("#", ""), 16);
    const r = (num >> 16) & 0xff;
    const g = (num >> 8) & 0xff;
    const b = num & 0xff;
    const lR = Math.round(r + (255 - r) * 0.9);
    const lG = Math.round(g + (255 - g) * 0.9);
    const lB = Math.round(b + (255 - b) * 0.9);
    const light = `#${((lR << 16) | (lG << 8) | lB).toString(16).padStart(6, "0")}`;
    root.style.setProperty("--color-primary-light", light);
  }, [firmData?.branding?.primaryColor, firmData?.branding?.accentColor, firmData?.isOnTrial, firmData?.subscriptionStatus]);

  return <>{children}</>;
};

export default ThemeProvider;
